<div class='AuthenticatedFooter'>
  <div class='AuthenticatedFooter-copyright container-fluid'>
    <div class='AuthenticatedFooter-copyright'>Copyright Retreva LLC</div>
  </div>
  <div class='AuthenticatedFooter-menu'>
    <app-authenticated-header-menu></app-authenticated-header-menu>
  </div>
</div>
